import { useState, useEffect, Fragment } from "react";
import { useQuery } from "@tanstack/react-query";

// styled components
import { KanbanContainer, KanbanBoard, KanbanTrack, KanbanTrackHeader, KanbanTrackHeaderTitle, KanbanTrackHeaderInfo, KanbanTrackHeaderActions, KanbanDot, KanbanScrollable, NoTickets } from "./Common"

// mui
import { useTheme, Button, Badge } from "@mui/material";

import { BasicFlex } from "../../../../utils/Common";

// mui icons
import AddIcon from '@mui/icons-material/AddRounded';

import { getStationView } from "../../apiService";


// zustand store
import useRepairDashboardStore from "../../../../store/repair_dashboard";

// api services
import { getRepairVendors } from "../../../Vendors/apiService";

// Kanban Ticket
import KanbanTicket from "../KanbanTicket";

// drawer
import SideDrawer from "../SideDrawer";

const VendorDashboard = ({ tickets = [], setTicket, setOpen }) => {

  console.log(tickets);

  const [sideBar, setSideBar] = useState({
      open: false,
      category: "",
      vendor: ""
    });

  const handleClose = () => {
    setSideBar({ open: false, category: "", vendor: "" });
  }

  const handleOpen = (vendor) => {
    setSideBar({ open: true, vendor });
  }

  const theme = useTheme();

  const sortedVendors = useRepairDashboardStore((state) => state.sortedVendors);
  const setSortedVendors = useRepairDashboardStore((state) => state.setSortedVendors);

  const { data: vendors } = useQuery({
    queryKey: ['vendors', 'repairs'],
    queryFn: () => getRepairVendors(),
    staleTime: 30 * 60 * 1000 // 30 minutes
  })

  const { data: repairView } = useQuery({
    queryKey: ['settings', 'repairs', 'vendor_view'],
    queryFn: () => getStationView('vendor_view'),
    staleTime: 30 * 60 * 1000 // 30 minutes
  })

  // set up stations
  useEffect(() => {
    if (repairView?.data?.length) {
      let sorted = repairView.data.map((st) => {
        if (st.name === "Repair Queue") {
          return { ...st, filter: (sts) => {return sts.filter((st) => st.status === "scheduled" || st.task_status === "scheduled")} };
        }
        if (st.name === "Repair Done") {
          return { ...st, filter: (sts) => {return sts.filter((st) => st.status === "in_progress" && st.task_status === "completed")} };
        }
        return st;
      })
      setSortedVendors(repairView.data);
    } else {
      let defaultStations = [
        { id: 1, name: "Repair Queue", active: true, filter: (sts) => {return sts.filter((st) => st.status === "scheduled" || st.task_status === "scheduled")}, noReception: true }
      ];
  
      if (vendors?.length) {
        defaultStations = defaultStations.concat(vendors.map((st, i) => ({ id: st.full_name, name: st.full_name, active: true, color: st.label_color })));
      }
  
      defaultStations.push({
        id: 0,
        color: theme.palette.success.light,
        name: "Repair Done",
        active: true,
        filter: (sts) => {return sts.filter((st) => st.status === "in_progress" && st.task_status === "completed")},
        noReception: true
      })
      setSortedVendors(defaultStations);
    }
  }, [vendors, repairView?.data]);

  return (
    <Fragment>
      <KanbanContainer>
        <KanbanBoard>
          {sortedVendors.filter((vendor) => vendor.active).map((vendor) => {
            let activeStatuses = ["accepted", "in_progress"];
            let inactiveStatuses = ["scheduled", "completed", "cancelled"];
            let filteredTickets = vendor && vendor.filter ? vendor.filter(tickets) : tickets?.filter((ticket) => ticket.vendor_name === vendor.name && activeStatuses.includes(ticket.status) && !inactiveStatuses.includes(ticket.task_status));
            return (
            <KanbanTrack key={vendor.id}>
              <KanbanTrackHeader $color={vendor.paletteColor || vendor.color}>
                <KanbanTrackHeaderInfo justify="flex-start">
                  {/* <KanbanDot $color={vendor.color} /> */}
                  <KanbanTrackHeaderTitle>{vendor.name}</KanbanTrackHeaderTitle>
                  <Badge badgeContent={filteredTickets.length} showZero={false} slotProps={{ badge: { sx: { bgcolor: "black", color: "white !important" } } }} />
                </KanbanTrackHeaderInfo>
                <KanbanTrackHeaderActions>
                  {/* { !vendor.noReception ? <Button size="small" sx={{p: 0, minWidth: "unset"}} color="text" onClick={() => handleOpen(vendor?.name)}><AddIcon  /></Button> : null } */}
                </KanbanTrackHeaderActions>
              </KanbanTrackHeader>
              <KanbanScrollable $static={vendor.noReception}>
                {filteredTickets.length ? <BasicFlex dir="column" width="100%" gap="1rem">
                  {filteredTickets.map((ticket) => (
                    <KanbanTicket key={ticket.repair_ticket_id} ticket={ticket} setTicket={setTicket} setOpen={setOpen} vendor={true} />
                  ))}
                </BasicFlex> : <NoTickets />}
              </KanbanScrollable>
            </KanbanTrack>
          )})}
        </KanbanBoard>
      </KanbanContainer>
      <SideDrawer sideBar={sideBar} handleClose={handleClose} />
    </Fragment>
  )
};

export default VendorDashboard;